import script from "./PopupUpdate.vue?vue&type=script&setup=true&lang=js"
export * from "./PopupUpdate.vue?vue&type=script&setup=true&lang=js"

import "./PopupUpdate.vue?vue&type=style&index=0&id=6fcf3a9a&lang=scss&scoped=true"

import exportComponent from "/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fcf3a9a"]])

export default __exports__